import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgMxnCircle = function SvgMxnCircle(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9071E",
        d: "M18 1.608c3.586 2.075 6 5.95 6 10.392s-2.414 8.316-6 10.39z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#006923",
        d: "M6 22.39C2.414 20.316 0 16.442 0 12S2.414 3.683 6 1.608z"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#F4F4F4",
        d: "M12 0c2.186 0 4.235.587 6 1.608v20.783A11.94 11.94 0 0 1 12 24a11.94 11.94 0 0 1-6-1.61V1.609A11.94 11.94 0 0 1 12 0"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#A8AC71",
        d: "M10.016 7.947a6 6 0 0 0-.22.395c.18.053.305.307.44.433.365.335.32.71-.18 1.116-.097.079.126.286.04.543.238.013.408.05.566.143.442.26.4.738.064 1.106a2.25 2.25 0 0 1-.857.581c-.5.18-1.033.11-1.033-.528 0-.025-.017-.075.22-.08-.38-.006-.537-1.05-.543-1.17 0-.794-.336-.794-.336-.794v-.427h.58c.33 0 .238.396.342.626.025-.042.067 1.313.202 1.2.052-.041.436.442.495.23.045-.16-.215-.789-.214-1.056 0-.621.195-.974.214-1-.083-.03-.207-.359-.263-.36-.514 0-.584-.108-.478-.563.057-.243-.137-.51.104-.91zm-.044 3.078.011-.01.005-.007z"
    })), _path5 || (_path5 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FCCA3D",
        fillRule: "evenodd",
        d: "M10.384 7.913s-.687.533-.558 1.1c.128.569 1.482 0 1.318-.55s-.76-.55-.76-.55",
        clipRule: "evenodd"
    })), _path6 || (_path6 = /*#__PURE__*/ React.createElement("path", {
        fill: "#8F4620",
        fillRule: "evenodd",
        d: "M15.267 12.403s.925-2.741-.546-4.16c-1.47-1.42-3.17-1.325-3.17-1.325s-.489.364 0 .641c.49.277.285.543.285.543s-.82-.832-1.364-.346c-.543.487.508.413.397.779s-.583 1.99.106 2.811c.69.82-.652.643-.379.643s1.24.19 1.24 0c0-.192.336.742.624.742.287 0 .51-.328.51-.328s.403.328.648.328c.246 0 1.103-.215 1.103-.215l-1.62-1.364s.098-.602-.132-.732 1.842 1.154 2.005 1.569c.162.414.293.414.293.414",
        clipRule: "evenodd"
    })), _path7 || (_path7 = /*#__PURE__*/ React.createElement("path", {
        fill: "#9FAB2F",
        d: "M7.066 11.727s.15-.479.311-.512c.14-.029.433.23.433.23.52 2.889 1.778 4.018 3.865 4.018 2.112 0 3.392-.858 4.139-3.523 0 0 .397-.406.537-.36.152.048.343.585.343.585-.856 3.058-2.475 4.419-5.02 4.419-2.567 0-4.01-1.54-4.608-4.857"
    })), _path8 || (_path8 = /*#__PURE__*/ React.createElement("path", {
        fill: "#2FC2DC",
        fillRule: "evenodd",
        d: "M9.334 13.656s3.005.638 4.19.638-1.04.968-1.909.968q-.57 0-1.374-.692c-.096-.082-.003-.267-.295-.27-.409-.003-.916-.099-.867-.157.046-.055.64-.072.583-.133-.095-.1-.328-.354-.328-.354",
        clipRule: "evenodd"
    })), _path9 || (_path9 = /*#__PURE__*/ React.createElement("path", {
        fill: "#F9AA51",
        d: "M10.667 14.267c0-.092.074-.167.166-.167H12.5c.092 0 .167.075.167.167v.738a.167.167 0 0 1-.167.166h-1.667a.167.167 0 0 1-.166-.166z"
    })), _path0 || (_path0 = /*#__PURE__*/ React.createElement("path", {
        fill: "#259485",
        d: "M8.176 12.136s0-.375.254-.574c.29-.229.564 0 .564 0 1.066 1.518 2.659 2.018 4.887 1.496 0 0 .667.218.7.361.043.182-.472.613-.472.613-2.605.61-4.618-.022-5.933-1.896"
    })), _path1 || (_path1 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FCCA3D",
        fillRule: "evenodd",
        d: "M12.591 12.35s-1.213.64-.809.64c.405 0 1.988.319 1.68 0-.308-.32-.87-.64-.87-.64M11.156 11.588s-.23-.666-.71-.666-.344.547-.575.547.215.384.413.384c.2 0 .872-.265.872-.265",
        clipRule: "evenodd"
    })));
};

export { SvgMxnCircle as ReactComponent };
//# sourceMappingURL=MXNCircle.svg.es.js.map
